
import rules from "@/services/helpers/validation-rules";
import DatePicker from "@/components/form-components/DatePicker.vue";
import Vue from "vue";
import General from "@/modules/applications/components/General.vue";
import Civil from "@/modules/applications/components/Civil.vue";
import Absolvation from "@/modules/applications/components/Absolvation.vue";
import API from "@/api/API";
import store from "@/store";
import ConfirmPrivacyDialog from "@/modules/applications/dialogs/ConfirmPrivacyDialog.vue";

export default Vue.extend({
  name: "index",

  components: {
    ConfirmPrivacyDialog,
    General,
    Civil,
    Absolvation,
    DatePicker,
  },

  data: () => ({
    rules,
    checkForm: false as any,
    model: {
      application: {
        need_hostel: false as boolean,
        application_study_types: [] as Array<any>,
      } as any,
      abiturient: {
        has_driving_license: false as boolean,
        is_married: false as boolean,
      } as any,
      abiturient_contacts: [] as Array<any>,
      graduated_university: {} as any,
      scientific_publications: [{} as any] as Array<any>,
      documents: [{} as any] as Array<any>,
      abiturient_documents: [
        { type: "diplom_copy", file: null },
        { type: "diplom_anex_copy", file: null },
        { type: "id_certificate", file: null },
        { type: "medical_certificate", file: null },
        { type: "payment", file: null },
        { type: "marry_certificate", file: null },
      ] as Array<any>,
      family_members: {
        mother: { role: "mother" } as any,
        father: { role: "father" } as any,
        husband: { role: "husband", home_phone: null } as any,
        children: [{ role: "child" } as any] as Array<any>,
      } as any,
      foreign_languages: [{} as any] as Array<any>,
      required_documents: {} as any,
    } as any,
    selects: {
      universities: [] as Array<SelectComponentInterface>,
      studyPrograms: [] as Array<SelectComponentInterface>,
    },
    localStorageKey: "form" as string,
    errorMessages: {} as any,
    selectedTab: 0 as number,
    allowedKeys: {
      general: [
        "abiturient.first_name",
        "abiturient.last_name",
        "abiturient.patronymic",
        "abiturient.birthday",
        "abiturient.sex",
        "abiturient.rh",
        "abiturient.blood_type",
        "abiturient.has_driving_license",
        "abiturient.nationality",
        "abiturient.residence_medium",
        "abiturient.region",
        "abiturient.locality",
        "abiturient.house",
        "abiturient.street",
        "abiturient.apartment",
        "abiturient_contacts",
        "abiturient.passport_series",
        "abiturient.passport_number",
        "abiturient.personal_code",
        "abiturient.personal_code_absence_reason",
        "abiturient.passport_issue_date",
        "abiturient.passport_issuer",
        "abiturient.passport_region",
        "abiturient.passport_locality",
        "abiturient.passport_house",
        "abiturient.passport_street",
        "abiturient.passport_apartment",
        "foreign_languages.*.language_id",
        "foreign_languages.*.level",
        "abiturient_documents.*.file",
        "abiturient_documents.*.type",
        ["application.need_hostel"] as Array<string>,
        "abiturient.is_married",
        "family_members.husband.full_name",
        "family_members.husband.birthday",
        "family_members.husband.workplace",
        "family_members.husband.home_phone",
        "family_members.husband.residence",
      ] as Array<string>,
      // civil: [
        // ["application.need_hostel"] as Array<string>,
        // "abiturient.is_married",
        // "family_members.husband.full_name",
        // "family_members.husband.birthday",
        // "family_members.husband.workplace",
        // "family_members.husband.home_phone",
        // "family_members.husband.residence",
        // "family_members.wife.full_name",
        // "family_members.wife.birthday",
        // "family_members.wife.workplace",
        // "family_members.wife.home_phone",
        // "family_members.wife.residence",
        // "family_members.father.full_name",
        // "family_members.father.home_phone",
        // "family_members.father.birthday",
        // "family_members.father.workplace",
        // "family_members.father.residence",
        // "family_members.mother.full_name",
        // "family_members.mother.home_phone",
        // "family_members.mother.birthday",
        // "family_members.mother.workplace",
        // "family_members.mother.residence",
        // "family_members.children.*.full_name",
        // "family_members.children.*.date",
      // ] as Array<string>,
      absolvation: [
        "graduated_university.name",
        "graduated_university.study_program_id",
        "graduated_university.obtained_title",
        "graduated_university.diploma_series",
        "graduated_university.diploma_number",
        "graduated_university.diploma_release_day",
        "graduated_university.general_marks_average",
        "graduated_university.exam_marks_average",
        "graduated_university.license_marks_average",
        "scientific_publications.*.number",
        "scientific_publications.*.type",
      ] as Array<string>,
    } as any,
    fullLoaded: false as boolean,
    arrayFields: {
      absolvation: "scientific_publications",
      // civil: "family_members.children",
      general: "abiturient_documents",
    } as any,
    formsErrors: {
      general: false,
      // civil: false,
      absolvation: false,
    },
    requiredDocuments: {} as any,
    editAction: false as any,
    loading: false as any,
  }),

  watch: {
    model: {
      immediate: true,
      deep: true,
      handler() {
        if (this.fullLoaded) {
          this.saveToLocalStorage();
        }
      },
    },
  },

  computed: {
    optionalDocuments() {
      return (
        this.model.abiturient_documents?.filter((item: any) =>
          item.type.startsWith("optional_copy_")
        ) || []
      );
    },
    user() {
      return this.$store.getters["user/info"];
    },
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const item =
        to.params.id &&
        (await API.applications().getForEdit(Number(to.params.id)));

      /*if (item) {
        const family_members = {
          mother: { role: "mother" } as any,
          father: { role: "father" } as any,
          husband: { role: "husband", home_phone: null } as any,
          children: [{ role: "child" } as any] as Array<any>,
        } as any;

        if (
          Array.isArray(item.family_members) &&
          item.family_members.length === 0
        ) {
          item.family_members = {};
        }

        for (const key in family_members) {
          if (!item.family_members?.[key]) {
            item.family_members[key] = family_members[key];
          }
        }
      }*/

      next((vm) => {
        if (
          ['admin', 'operator'].includes(vm.$store.getters["user/info"].role.name)
          && !to.params.id
        ) {
          vm.$router.push("/application_requests");
          return;
        }

        if (item) {
          vm.model = {
            ...item,
          };
          vm.editAction = true;
        } else {
          vm.checkFormData();
        }

        vm.$nextTick(() => {
          vm.fullLoaded = true;
        });
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    checkErrorMessage(key: string) {
      if (this.errorMessages[key]) {
        delete this.errorMessages[key];
      }

      if (this.checkForm) {
        this.passedValidation();
      }

      this.$forceUpdate();
    },
    passedValidation(): boolean {
      const generalForm = this.$refs.generalForm as Vue;
      const absolvationForm = this.$refs.absolvationForm as Vue;
      // const civilForm = this.$refs.civilForm as Vue;

      this.formsErrors.general = !generalForm.validate();
      this.formsErrors.absolvation = !absolvationForm.validate();
      // this.formsErrors.civil = !civilForm.validate();

      return (
        generalForm.validate() &&
        absolvationForm.validate()
        // civilForm.validate()
      );
    },
    switchToTab(): void {
      const generalForm = this.$refs.generalForm as Vue;
      const absolvationForm = this.$refs.absolvationForm as Vue;
      // const civilForm = this.$refs.civilForm as Vue;

      const forms = [generalForm, absolvationForm];

      for (const index in forms) {
        if (!forms[index].validate()) {
          this.selectedTab = Number(index);
          return;
        }
      }
    },
    parseModel(): any {
      const model = { ...this.model };

      model.abiturient_contacts = model.abiturient_contacts.map(
        (item: string) => ({
          type: "phone",
          value: item,
        })
      );

      const general_marks_average = String(
        model.graduated_university.general_marks_average
      ).replace(",", ".");
      const exam_marks_average = String(
        model.graduated_university.exam_marks_average
      ).replace(",", ".");
      const license_marks_average = String(
        model.graduated_university.license_marks_average
      ).replace(",", ".");

      if (model.graduated_university.name.hasOwnProperty("text")) {
        model.graduated_university.name = model.graduated_university.name.text;
      }

      model.scientific_publications = model.scientific_publications.filter(
        (item: any) => item.number && item.type
      );

      return {
        ...model,
        graduated_university: {
          ...model.graduated_university,
          general_marks_average,
          exam_marks_average,
          license_marks_average,
        },
      };
    },
    checkTabs() {
      this.switchToTab();
      return this.passedValidation();
    },
    async submit() {
      this.loading = true;
      try {
        if (this.checkTabs()) {
          if (this.editAction) {
            await this.$API
              .applications()
              .edit(this.$route.params.id, this.parseModel());
            await this.$store.dispatch(
              "alert/showSuccess",
              this.$t("global-alert.successful_edit")
            );
          } else {
            await this.$API.applications().create(this.parseModel());
            await this.$store.dispatch(
              "alert/showSuccess",
              this.$t("global-alert.successful_create")
            );
          }
          this.errorMessages = {};
          this.clearLocalStorage();

          if (this.user.role.name === "guest") {
            await this.$router.push("/preview");
            return;
          }

          await this.$router.push(
            `/application_requests/preview/${this.$route.params.id}`
          );
        } else {
          await this.$store.dispatch(
            "alert/showError",
            this.$t("applications.tooltips.correct")
          );
          this.checkForm = true;
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    checkFormData() {
      if (localStorage.getItem(this.localStorageKey)) {
        this.model = JSON.parse(localStorage.getItem(this.localStorageKey));
      }
      this.fullLoaded = true;
    },
    saveToLocalStorage() {
      localStorage.setItem(this.localStorageKey, JSON.stringify(this.model));
    },
    clearLocalStorage() {
      localStorage.removeItem(this.localStorageKey);
    },
    setForeignLanguages(event: Array<any>): void {
      this.model.foreign_languages = event;
    },
    showErrorTab(key: string): boolean {
      let hasError = false;
      if (!this.allowedKeys[key]) {
        return false;
      }

      for (const error in this.errorMessages) {
        for (const item of this.allowedKeys[key]) {
          if (
            this.allowedKeys[key].includes(error) ||
            error.startsWith(this.arrayFields[key])
          ) {
            hasError = true;
          }
        }
      }
      return hasError;
    },
    changeTab(direction: number): void {
      const generalForm = this.$refs.generalForm as Vue;
      const absolvationForm = this.$refs.absolvationForm as Vue;
      // const civilForm = this.$refs.civilForm as Vue;

      const forms = [generalForm, absolvationForm];
      const currentTab = forms[this.selectedTab];

      if (currentTab.validate()) {
        if (
          this.selectedTab + direction >= 0 &&
          this.selectedTab + direction < forms.length
        ) {
          this.selectedTab += direction;
        }
      }
    },

    back() {
      this.$router.back();
    },
  },
});
